<template>
    <div class="station">
        <div class="station-form">
            <div class="form-title"><span>申请站点授权</span></div>
            <p class="form-cont">请输入您希望获取授权的运营商账号（以手机号或运营商名称搜索），通过运营商授权后，您将会收到授权通知</p>
            <div>
                <div class="search">
                  <el-input v-model="keyWords" class="search-input" placeholder="请输入手机号或运营商名称" :required="true">
                      <i class="el-icon-search" slot="prepend"></i>
                  </el-input>
                  <el-button @click="handelSearch">搜索</el-button>
                  <div class="cover" v-if="dataList.length && showCover" @click="handelShowCover"></div>
                  <el-scrollbar class="datalist" :class="dataList.length > 5 ? 'maxheight' : ''" v-if="dataList.length && showCover">
                      <div class="item" v-for="(item, index) in dataList" :key="index" choosed="item.chooded">
                          <div>
                              <p>{{item.phone}}</p>
                              <p>{{item.commName}}</p>
                          </div>
                          <div>
                              <el-button @click="handelAdd(item,index)" v-if="!item.choosed">添加</el-button>
                              <el-button type="primary" @click="handelRemove(item,index)" v-if="item.choosed">移除</el-button>
                          </div>
                      </div>
                  </el-scrollbar>
              </div>
              <div>
                <el-card class="box-card" v-if="commercialList.length && !showCover">
                    <div slot="header" class="clearfix">
                        <span>您将向以下运营商发起授权申请</span>
                    </div>
                    <el-scrollbar :class="commercialList.length > 8 ? 'cmaxheight' : ''">
                      <div v-for="(item, index) in commercialList" :key="index" class="item">
                          {{item.commName}}
                      </div>
                    </el-scrollbar>
                    
                </el-card>
                <div class="form-btn" v-if="commercialList.length && !showCover">
                    <el-button type="primary" v-if="commercialList.length" @click="handelSubmit">确认提交</el-button>
                </div>
              </div>
            </div>
        </div>
        
    </div>
</template>
<script>
import { http, apiJson } from "@/utils/http";
import { Message } from "element-ui";
export default {
  data() {
    return {
      commercialList: [],
      dataList: [],
      keyWords: "",
      showCover: false
    };
  },
  mounted() {
    this.$store.dispatch("changeDefaultActive", "records");
  },
  methods: {
    handelSearch() {                             
      this.dataList = []
      this.commercialList = []
      if (this.keyWords) {
        http(apiJson.getCommercial, { keyWords: this.keyWords }).then(res => {
          if (res.code == 0) {
            if (res.data != null && res.data.length > 0) {
              this.dataList = res.data;
              this.showCover = true;
            } else {
              Message.warning("暂无数据");
            }
          } else {
            Message.error(res.message);
          }
        });
      } else {
        Message.warning("请输入手机号或运营商名称");
      }
    },
    handelAdd(item,index) {
      let dataList = [...this.dataList]
      dataList[index].choosed = true
      this.dataList = dataList
      this.commercialList.push({
        commName: item.commName,
        commid: item.commid
      })
    },
    handelRemove(item,index) {
      let dataList = [...this.dataList]
      dataList[index].choosed = false
      this.dataList = dataList
      let i = this.arrayToIndex(item.commName)
      this.commercialList.splice(i,1)
    },
    handelShowCover() {
      this.showCover = false;
    },
    handelSubmit () {
      let options = {
        appId: this.$route.params.id,
        data: this.commercialList
      }
      console.log(options)
      http(apiJson.applySites, options).then(res => {
        console.log(res)
        if(res.code == 0 && res.data) {
          Message.success(res.data)
          let {params} = this.$route
          this.$router.push( `/create-app/${params.id}/records`)
        }
      })
    },
    arrayToIndex (commName) {
      let arry = this.commercialList
      for(let i = 0; i < arry.length; i++) {
        console.log(arry[i].commName)
        if(arry[i].commName == commName) {
          return i
        }
      }
      return null
    }
  }
};
</script>
<style lang="scss" scoped>
.station {
  height: 720px;
  width: 100%;
  border-left: 1px solid #e5e5e5;
  .station-form {
    width: 780px;
    margin: 0 auto;
    .form-title {
      padding-bottom: 10px;
      width: 100%;
      font-size: 16px;
      color: #666666;
      font-weight: bold;
      margin: 60px 0 30px;
      border-bottom: 1px solid #e5e5e5;
      span {
        padding-left: 14px;
        border-left: 4px solid #3296fa;
      }
    }
    .form-cont {
      font-size: 16px;
      line-height: 24px;
      color: #333;
      letter-spacing: -0.27px;
    }
    .form-flex {
      display: flex;
      justify-content: space-around;
      animation: flexs 3s;
      @keyframes flexs {
        0% {
          display: block;
        }
        100% {
          display: flex;
          justify-content: space-around;
        }
      }
    }
    .search {
      width: 380px;
      position: relative;
      margin: 20px auto;
      .search-input {
        width: 280px;
        margin-right: 10px;
      }
      .cover {
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        left: 0;
        background: rgba($color: #000000, $alpha: 0);
      }
      .datalist {
        position: absolute;
        top: 40px;
        left: 0;
        width: 280px;
        border-radius: 0 0 4px 4px;
        box-shadow: 0 2px 4px 0 #d6d6d6;
        border: 1px solid #d6d6d6;
        padding-bottom: 10px;
        overflow: hidden;
        background: #ffffff;
        &.maxheight {
          height: 360px;
        }
        & /deep/ .el-scrollbar__wrap {
          overflow-x: hidden;
        }
        .item {
          width: 280px;
          height: 72px;
          display: flex;
          & > div {
            &:first-child {
              padding-top: 17px;
              width: 100%;
            }
            &:last-child {
              width: 100px;
              padding: 20px;
            }
          }
          button {
            width: 60px;
            height: 32px;
            padding: 0;
            margin: 0;
            cursor: pointer;
            outline: none;
          }
          p {
            width: 160px;
            padding-left: 20px;
            overflow: hidden;
            font-size: 14px;
            color: #666666;
            line-height: 20px;
            // height: 20px;
            // text-overflow: ellipsis;
            // white-space: nowrap;
          }
        }
      }
    }
    .box-card {
      width: 370px;
      margin: 0 auto;
      text-align: center;
      & /deep/ .el-card__header, & /deep/ .el-card__body {
        padding: 0;
      }
      .item {
        height: 40px;
        line-height: 40px;
        font-size: 14px;
        color: #666666;
      }
      .cmaxheight {
        height: 320px;
        overflow: hidden;
        & /deep/ .el-scrollbar__wrap {
          overflow-x: hidden;
        }
      }
    }
    .form-btn {
      width: 100px;
      margin: 31px auto;
      .el-button {
        color: #ffffff;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/CreateApp/station.vue